import { useSelector } from 'react-redux';
//@ts-ignore untyped file
import { getCurrentThreadId } from '../selectors/getCurrentThreadId';
import { jsx as _jsx } from "react/jsx-runtime";
export function withThreadId(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return props => {
    const threadId = useSelector(getCurrentThreadId);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      threadId: threadId != null ? String(threadId) : undefined
    }));
  };
}